import { Col, Row } from 'react-bootstrap';

const ModuleColumn = ({ title, iconClass, items }) => {
    return (
        <Col xs={12} md={8} lg={6} className='px-0 px-sm-3 p-3 p-lg-4 ab-module-panel'>
            <Row className='px-5 py-3 p-sm-3 align-items-center br-4 cursor-default'>
                <Col xs={2} className='d-grid justify-content-center'>
                    <div class="feature-icon ms-0 ms-lg-5">
                        <i className={`fa-solid ${iconClass} fa-2xl`}></i>
                    </div>
                </Col>
                <Col className='ps-3 ps-md-4 ps-lg-5'>
                    <h5 className=''>{title}</h5>
                    <ul>
                        {items.map((item, idx) => (
                            <li key={idx}>{item}</li>
                        ))}
                    </ul>
                </Col>
            </Row>
        </Col>
    );
};

export default ModuleColumn;
